import React from 'react';
import {SelectItemType} from "../../../components/ui/selects/DefaultSelect";
import {ALL_CYCLES, ALL_GROUPS_TYPES, ALL_GROUPS_TYPES_RAW_DATA} from "../../../utils/consts";
import {callApi} from "../../../utils/callApi";
import {API_ROUTE_PATH} from "../../../utils/api_routes";
import {deepClone} from "../../../utils/deepClone";


export const useRawData = () => {
    const [selectTeams, setSelectTeams] = React.useState<SelectItemType[]>([]);
    const [selectedTeam, setSelectedTeam] = React.useState<SelectItemType | null>(
        null
    );

    const [selectWorksapces, setSelectWorksapces] = React.useState<SelectItemType[]>([]);
    const [selectedWorkspace, setSelectedWorkspace] =
        React.useState<SelectItemType | null>(null);
    const [startDate, setStartDate] = React.useState<Date | null>(null);
    const [endDate, setEndDate] = React.useState<Date | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const refLinkCvs = React.useRef<any>(null);
    const [selectedPackage, setSelectedPackage] = React.useState<SelectItemType | null>(null);
    const [selectedAssessment, setSelectedAssessment] = React.useState<SelectItemType | null>(null);
    const [selectedCycles, setSelectedCycles] = React.useState<string[]>([]);
    const [selectCycles, setSelectCycles] = React.useState<SelectItemType[]>([]);

    const [activeCyclesLinks, setActiveCyclesLinks] = React.useState<SelectItemType[]>(
        []
    );
    const [selectOriginSource, setSelectOriginSource] = React.useState<SelectItemType[]>([ALL_GROUPS_TYPES]);
    const [selectedOriginSource, setSelectedOriginSource] = React.useState<SelectItemType[] | null>([ALL_GROUPS_TYPES]);


    const ref = React.useRef(null);

    const cycleSelectHandler = (data: SelectItemType) => {
        if (
            data.value === ALL_CYCLES.value &&
            activeCyclesLinks[0].value === ALL_CYCLES.value
        ) {
            return null;
        }
        const newData = deepClone(activeCyclesLinks) as SelectItemType[];
        const links: string[] = [];

        if (data.value === ALL_CYCLES.value) {
            setActiveCyclesLinks([ALL_CYCLES]);
            selectCycles.forEach((itm) => {
                if (itm.value !== ALL_CYCLES.value) {
                    links.push(itm.value);
                }})
            setSelectedCycles(links)
            return
        }

        let hasVal = false;

        if (newData[0] && newData[0].value === ALL_CYCLES.value) {
            newData.splice(0, 1);
        }

        newData.forEach((itm, i) => {
            if (itm.value === data.value) {
                newData.splice(i, 1);
                hasVal = true;
            }
        });

        if (!hasVal) {
            newData.push(data);
        }

        newData.forEach((itm) => {
            if (itm.value !== ALL_CYCLES.value) {
                links.push(itm.value);
            }
        });

        if (!newData[0]) {
            newData.push(ALL_CYCLES);
        }

        setActiveCyclesLinks(newData);
        setSelectedCycles(links)
        return
    };

    const genCSV = async () => {
        if (!selectedWorkspace) return null;
        if (!selectedPackage) return null;
        if (!selectedAssessment) return null;
        if(!selectedCycles) return null;
        setIsLoading(true);
        try {
            const resp = await callApi({
                method: 'post',
                path: API_ROUTE_PATH.admins.genCsvByParams(
                    selectedWorkspace.id as string,
                    selectedAssessment.id as string,
                    selectedPackage.id as string,
                ),
                data: {
                    links: selectedCycles,
                    origin_sources: selectedOriginSource[0].id === ALL_GROUPS_TYPES_RAW_DATA.id ? [] : selectedOriginSource.map(originSource => originSource.id as string),
                    is_all_origin_sources : selectedOriginSource[0].id === ALL_GROUPS_TYPES_RAW_DATA.id,
                    is_private_data_hidden: false,
                },
                responseType: 'blob',
            });

            const outputFilename = `Raw_data_${selectedAssessment?.title}.xlsx`;

            // If you want to download file automatically using link attribute.
            const url = URL.createObjectURL(resp);
            const linkDoc = document.createElement('a');
            linkDoc.href = url;
            linkDoc.setAttribute('download', outputFilename);
            document.body.appendChild(linkDoc);
            linkDoc.click();
        } catch (e) {
            console.log(e);
            alert(JSON.stringify(e));
        } finally {
            setIsLoading(false);
        }
    };

    return {
        selectTeams,
        setSelectTeams,
        selectedTeam,
        setSelectedTeam,
        selectWorksapces,
        setSelectWorksapces,
        selectedWorkspace,
        setSelectedWorkspace,
        selectedOriginSource,
        setSelectedOriginSource,
        selectOriginSource,
        setSelectOriginSource,
        refLinkCvs,
        ref,
        isLoading,
        genCSV,
        selectedAssessment,
        selectedPackage,
        selectedCycles,
        setSelectedAssessment,
        setSelectCycles,
        selectCycles,
        setSelectedPackage,
        setSelectedCycles,
        cycleSelectHandler,
        activeCyclesLinks,
        setActiveCyclesLinks,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
    };
};